import { soldActions } from '../../helpers/purchase-order-actions-helper-seller';
import { boughtActions } from '../../helpers/purchase-order-actions-helper-buyer';
import { logger } from 'packages/logger';
import { PAGE_NAMES } from '../../constants/page';

export const getActionsForPurchaseOrder = (
    purchaseOrder,
    listViewType,
    memberMessagingParticipation,
    pageName
) => {
    const secondaryActions = [];
    let primaryAction = null;

    const checkAndAdd = action => {
        try {
            if (!action.isVisible) {
                throw 'Action is not compatible: ' + action.label;
            }
            if (!action.isVisible()) {
                return;
            }
            if (primaryAction === null && action.isPrimaryAction()) {
                // eslint-disable-next-line better-mutation/no-mutation
                primaryAction = action;
            } else {
                secondaryActions.push(action);
            }
        } catch (error) {
            logger(error);
        }
    };

    const resolveActions = potentialActions => {
        potentialActions.forEach(actionCreator => {
            const action = actionCreator();
            checkAndAdd(action);
        });
        return {
            primaryAction,
            secondaryActions
        };
    };

    let actionsForItem = [];

    switch (pageName) {
        case PAGE_NAMES.SellerSold:
            actionsForItem = resolveActions(
                soldActions(
                    purchaseOrder,
                    listViewType,
                    memberMessagingParticipation
                )
            );
            break;
        case PAGE_NAMES.BuyerPurchases:
            actionsForItem = resolveActions(
                boughtActions(purchaseOrder, listViewType)
            );
            break;
    }
    return actionsForItem;
};
